import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/reset.css";
import "./styles/global.css";
import "swiper/css";
import "react-tooltip/dist/react-tooltip.css";
import { configureAxios } from "./helpers/AxiosHelper";

//subir configurações pré definidas do axios.
configureAxios();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();